<template>
    <div class="time-component">
        <b-timepicker
            rounded
            placeholder="Click to select..."
            icon="clock"
            :enable-seconds="false"
            hour-format="12"
            locale="en-US"
            :required="required"
            :time-parser="parseTime()"
            v-bind:value="valueAsDate"
            v-on:input="valueChanged($event)">
        </b-timepicker>
    </div>
</template>

<script>

var moment = require('moment');

export default {
    name: 'Time',
    components: {
    },
    props: {
        component: Object,
        value: String,
        required: Boolean,
    },
    data: function () {
        return {
        }
    },
    methods: {
        valueChanged (event) {
            // console.log('value changed')
            // console.log(event)
            let time = moment(event)
            this.value = time.format('h:mm A')
            // console.log(time.format('h:mm A'))
            this.$emit('input', time.format('h:mm A'))
        },
        parseTime (x) {
            // console.log('parseTime')
            return moment(this.value).format('h:mm A')
        },
    },
    mounted(){

    },     
    computed: {
        valueAsDate () {
            return moment(this.value, 'h:mm A')
        },
    }
}

</script>

<style>

</style>

